import {styled} from "@mui/material/styles"
import {Accordion, AccordionSummary, AccordionDetails, Typography} from "@mui/material"

export const StyledAccordion = styled(Accordion)`
    && {
        background: transparent;
        margin: auto;
        border-width: 0;
        border-radius: 0;
        border-style: none;
        border-bottom: ${props => props.theme.colours.plp.facetDivider};
    }

    &::before {
        content: none;
    }
`

export const StyledAccordionSummary = styled(AccordionSummary)`
    min-height: 2.25rem;
    &.Mui-expanded {
        min-height: 2.25rem;
    }
    &.Mui-focused {
        background-color: transparent;
    }
    padding: 0;

    & .MuiAccordionSummary-content {
        margin: 0.4375rem 0;
        &.Mui-expanded {
            margin: 0.4375rem 0;
        }
    }

    & .MuiAccordionSummary-expandIconWrapper {
        margin-right: 0.5rem;
        padding: 12px;
    }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
    && {
        padding: 0 0 1rem 0;
    }
`

export const ExpansionTitle = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-transform: ${({theme}) => `${theme.colours.plp.filters.titleTransform}`};
`
export const ClearLink = styled("button")`
    position: absolute;
    right: 2.8rem;
    top: 0rem;
    height: 2.25rem;
    vertical-align: middle;
    z-index: 1;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: right;

    [dir="rtl"] & {
        text-align: left;
    }

    &:hover {
        background: none;

        > * {
            text-decoration: underline;
        }
    }

    > font {
        max-width: calc(100% - 1rem);
        overflow: hidden;
        text-overflow: ellipsis;
    }
`
export const FieldSet = styled("fieldset")`
    padding: 0;
    border: none;
    margin: 0;
    position: relative;
`

export const StyledTypography = styled(Typography)<{component: "p"}>`
    max-width: 100%;
    color: ${({theme}) => theme.colours.text.hyperlink};
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: ${({theme}) => `${theme.colours.font.primary.medium.weight}`};
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
`

export const Legend = styled("legend", {shouldForwardProp: prop => prop !== "isFilterSelected"})<{
    isFilterSelected: boolean | undefined
}>`
    ${({isFilterSelected}) =>
        isFilterSelected &&
        `overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 5rem;`}
`
